import { render, staticRenderFns } from "./WalletTransactionProgressBar.vue?vue&type=template&id=6c930632&"
import script from "./WalletTransactionProgressBar.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./WalletTransactionProgressBar.vue?vue&type=style&index=0&id=6c930632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports